import axios from "axios";
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "vectron-token";
const LEGACY_TOKEN_KEY = "vectron-admin-token";
const USER_KEY = "vectron-user";
const AUTH_EVENT = "vectron-auth-change";
const notify = () => window.dispatchEvent(new Event(AUTH_EVENT));

export const getToken = () => localStorage.getItem(TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY);
export const setToken = (t) => {
  localStorage.setItem(TOKEN_KEY, t);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  notify();
};
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};
const publicUser = (u) => (u ? { id: u.id, email: u.email, name: u.name, role: u.role } : null);
export const setUser = (u) => {
  localStorage.setItem(USER_KEY, JSON.stringify(publicUser(u)));
  notify();
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  notify();
};
export const clearToken = clearAuth;

export const authApi = axios.create({ baseURL: `${API}/api` });
authApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const adminApi = authApi;

export const ROLE_HOME = { customer: "/portal", partner: "/partner", admin: "/admin" };
export const ROLE_LOGIN = { customer: "/portal/login", partner: "/partner/login", admin: "/admin/login" };
export const ROLE_LABEL = { customer: "Customer", partner: "Manufacturing Partner", admin: "VECTRON Admin" };

const snapshot = () => {
  const token = getToken();
  if (!token) return { status: "anon", user: null };
  const user = getUser();
  return { status: user?.role ? "authed" : "loading", user };
};

/** Header-level view of the EXISTING session (token + cached user, revalidated against /auth/me). Not an authorization boundary. */
export const useAuthSession = () => {
  const [session, setSession] = useState(snapshot);
  useEffect(() => {
    let alive = true;
    const sync = async () => {
      const next = snapshot();
      setSession(next);
      if (next.status === "anon") return;
      try {
        const { data } = await authApi.get("/auth/me");
        if (!alive) return;
        localStorage.setItem(USER_KEY, JSON.stringify(publicUser(data)));
        setSession({ status: "authed", user: publicUser(data) });
      } catch (err) {
        if (alive && [401, 403].includes(err?.response?.status)) clearAuth();
      }
    };
    sync();
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      alive = false;
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return session;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
};
